module.exports = __webpack_public_path__ + "img/galactose.2db64865.png";